import { useTranslation } from 'react-i18next';

import { SpeciesGroupId } from '@/api/rest/resources/conservation';
import { GenericTable } from '@/components/widgets/o/GenericTable/GenericTable';
import { useProject } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useProject';
import { MetadataColumn } from '@/utils/table/mergeColumns';

export type SpeciesDetectedData = {
  group: SpeciesGroupId;
  species: string[];
};

export const TableTile = ({ data }: { data: SpeciesDetectedData[] }) => {
  const { t } = useTranslation();
  const project = useProject();

  const columns = [
    {
      accessorKey: 'indicatorGroup',
      header: () => <ColumnCell text={t('shared.ncaDetail.indicatorSpecies.speciesDetected.table.indicatorGroup')} />,
      cell: ({ row }) => <BodyCell text={project?.speciesGroups?.[row.original.group]} />,
    },
    {
      accessorKey: 'species',
      header: () => <ColumnCell text={t('shared.ncaDetail.indicatorSpecies.speciesDetected.table.species')} />,
      cell: ({ row }) => <BodyCell text={row.original.species.join(', ')} />,
    },
  ] as MetadataColumn<SpeciesDetectedData>[];

  return (
    <>
      {project?.name && (
        <span className='typography-body1 mb-6' data-testid='species-detected-table-explainer'>
          {t('shared.ncaDetail.indicatorSpecies.speciesDetected.table.explainer', {
            projectName: project.name,
          })}
        </span>
      )}
      <GenericTable
        defaultColumns={columns}
        data={data}
        className='border-none shadow-none bg-[#fbfbfb]'
        styles={{ cell: 'py-2' }}
      />
    </>
  );
};

const ColumnCell = ({ text }: { text: string }) => {
  return <span className='typography-overline'>{text}</span>;
};

const BodyCell = ({ text }: { text: string | undefined }) => {
  return <span className='typography-body2'>{text ?? '--'}</span>;
};
